import { useRef } from 'react'
import { Typography } from '@cockpitai/components/atoms/Typography'
import { allMonths, formatDate } from '@cockpitai/utils/dateFormatter'
import { capitalize } from '@cockpitai/utils/strings'
import { ModalTempForm, TModalTempFormRef } from './ModalTempForm'
import { VariantProps, tv } from 'tailwind-variants'

function parseLabel(placeholder: string, value?: any) {
  if (value && Object.keys(value).length === 0) return placeholder

  if (value?.option === 1) {
    return `em ${capitalize(formatDate(value.endDate, 'MMMM'))}`
  }

  if (value?.option === 2) {
    return `em ${allMonths.find((item) => item.value === value.endMonth)?.title} ${value?.endYear}`
  }
}

const scheduleDateTv = tv({
  base: 'flex h-10 w-full items-center rounded-lg bg-gray-800 px-4',
  variants: {
    isInvalid: {
      true: 'border-danger-500  shadow-danger-500 border shadow-sm focus-visible:outline-danger-500 border-opacity-100',
    },
  },
})

type TScheduleDateProps = {
  placeholder: string
  value?: unknown
  isInvalid?: boolean
  message?: string
  onChange(value: unknown): void
} & VariantProps<typeof scheduleDateTv>

export function ScheduleDate({
  value,
  placeholder,
  onChange,
  isInvalid,
}: TScheduleDateProps) {
  const refModalSchedule = useRef<TModalTempFormRef>(null)

  return (
    <>
      <button
        onClick={() => refModalSchedule?.current?.open(value)}
        type="button"
        className={scheduleDateTv({ isInvalid })}>
        <Typography
          type="bodyOne"
          className={value ? 'text-white/70' : 'text-gray-500'}>
          {parseLabel(placeholder, value)}
        </Typography>
      </button>

      <ModalTempForm ref={refModalSchedule} onChange={onChange} />
    </>
  )
}
